/* v2p.js — Val2Print 3D Shopify Theme */

document.addEventListener('DOMContentLoaded', function () {

  // ── HEADER SCROLL ──
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // ── BURGER MENU MOBILE ──
  const burger = document.getElementById('burger');
  const mobileNav = document.getElementById('mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      const open = mobileNav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
      const spans = burger.querySelectorAll('span');
      if (open) {
        spans[0].style.transform = 'rotate(45deg) translate(5px,5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px,-5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
  }

  // ── SCROLL REVEAL ──
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          const delay = e.target.style.getPropertyValue('--delay') || '0s';
          setTimeout(function () {
            e.target.classList.add('visible');
          }, parseFloat(delay) * 1000);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  // ── 3D CARD HOVER ──
  document.querySelectorAll('.pcard').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      if (window.innerWidth < 900) return;
      const r = this.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      this.style.transform = 'translateY(-8px) rotateY(' + (x * 4) + 'deg) rotateX(' + (-y * 4) + 'deg)';
      this.style.transition = 'none';
    });
    card.addEventListener('mouseleave', function () {
      this.style.transform = '';
      this.style.transition = 'all 0.5s cubic-bezier(0.4,0,0.2,1)';
    });
  });

  // ── ADD TO CART AJAX ──


  // ── VARIANT SELECTION ──
  const vbtns = document.querySelectorAll('.vbtn');
  if (vbtns.length > 0) {
    vbtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const pos = this.dataset.pos;
        document.querySelectorAll('.vbtn[data-pos="' + pos + '"]')
          .forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');

        // Build selected options
        const selected = [];
        document.querySelectorAll('.variant-opt').forEach(function (opt) {
          const active = opt.querySelector('.vbtn.active');
          if (active) selected.push(active.dataset.val);
        });

        // Match variant
        const variants = window.__v2p_variants || [];
        const match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (match) {
          const vidInput = document.getElementById('vid');
          if (vidInput) vidInput.value = match.id;
          const cartBtn = document.querySelector('.btn-cart');
          if (cartBtn) {
            cartBtn.disabled = !match.available;
            cartBtn.textContent = match.available ? 'Ajouter au panier →' : 'Épuisé';
          }
          const priceEl = document.querySelector('.product-price span');
          if (priceEl && match.price) {
            const formatted = (match.price / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
            priceEl.textContent = formatted;
          }
        }
      });
    });
  }

});
